import api from '../../../api/clinique/_soin_hospitalisation'

const state = () => ({
    soins_en_cours: [],
    jour_cats: [], //  ID des jours programmés pour les conduites à tenir
    liste_soin_actes: [],
})

// getters
const getters = {
    soins_en_cours: (state) => {
        return state.soins_en_cours
    },

    jour_cats: (state) => {
        return state.jour_cats
    },

    liste_soin_actes: (state) => {
        return state.liste_soin_actes
    },
}

// mutations
const mutations = {
    SET_SOIN_EN_COURS(state, soin) {
        state.soins_en_cours = soin;
    },

    SET_JOUR_CATS(state, jours) {
        state.jour_cats = jours;
    },

    SET_LISTE_SOIN_ACTES(state, tarif) {
        state.liste_soin_actes = tarif
    },
}

// actions
const actions = {
    /**
     * Récupère les soins & hospitalisation  en cours
     * @param {*} param0 
     * @returns 
     */
    getSoinsEnCours({ commit }) {
        return new Promise((resolve) => {
            api.getSoinsEnCours().then(
                response => {
                    commit('SET_SOIN_EN_COURS', response)
                    resolve(response)
                }
            )
        })
    },


    getSoinsEnCoursByConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoinsEnCoursByConsultation(data.consultation_id, data.soins_state).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
    getSoinsEnCoursByDate({ commit }, date) {
        return new Promise((resolve, reject) => {
            api.getSoinsEnCoursByDate(date).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit('SET_SOIN_EN_COURS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    sendStateSoinsValider({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.sendStateSoinsValider(data).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    sendStateSoinsValiderTraite({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.sendStateSoinsValiderTraite(data).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    // enregistrer soins sans consultation
    saveSoinsSansConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.saveSoinsSansConsultation(data).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    setFactureActeSoins({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.setFactureActeSoins(data).then(
                response => {
                    commit
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },


    /**
     * Récupère les soins & hospitalisation  en cours
     * @param {*} param0 
     * @returns 
     */
    getCatJourID({ commit }, idConsultation) {
        return new Promise((resolve) => {
            api.getCatJourID(idConsultation).then(
                response => {
                    resolve(response)
                    commit('SET_JOUR_CATS', response)
                }
            )
        })
    },

    getCatJourIDTraite({ commit }, data) {
        return new Promise((resolve) => {
            api.getCatJourID(data.id_consult, data.state_traite).then(
                response => {
                    resolve(response)
                    commit('SET_JOUR_CATS', response)
                }
            )
        })
    },

    deactiveJourCat({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.deactiveJourCat(data.jour_id, data.etat).then(
                response => {
                    resolve(response)
                    commit('SET_SOIN_EN_COURS', response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getTarifSoins({ commit } ) {
        return new Promise((resolve, reject) => {
            api.getTarifSoins().then(
                response => {
                    commit('SET_LISTE_SOIN_ACTES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}